import React, { Fragment, useState, useEffect } from 'react';
import axios from "axios";

import styles from './index.module.scss';

import ContentCMS from "../../../components/ContentCMS/ContentCMS";
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import Container from "../../../hoc/Container/Container";
import Head from "../../../layout/Head/Head";
import Loading from "../../../components/Loading/Loading";

const PrivacyPolicyPage = props => {
  const [privacyPolicy, setPrivacyPolicy] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/singletons/get/privacy`)
      .then(response => {
        setPrivacyPolicy(response.data.content ? response.data.content : []);
      })
      .catch(error => console.log('error', error));
  }, []);

  return (
    <Fragment>
      {privacyPolicy.length ?
        <Fragment>
          <Head title='Connatix - Privacy Policy' />
          <Container>
            <Breadcrumbs {...props} currentPositionText='Privacy Policy'/>
            <main className={styles['privacy-policy']}>
              <ContentCMS data={privacyPolicy}/>
            </main>
          </Container>
        </Fragment>
        :
        <Loading/>
      }
    </Fragment>
  );
};

export default PrivacyPolicyPage;
